import { Box, styled } from '@mui/material'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CampaignSimulationPreview from './CampaignSimulationPreview'
//@ts-ignore
import SlickSlider from 'react-slick'

import LayoutAccordion from '@/common/components/Layout/LayoutPageContent/LayoutAccordion'
import { theme } from '@/theme/theme'
import { useCampaign } from '@/api/campaigns/get'

type CampaignPreviewParams = {
  campaignId: string
}

const CampaignPreview: FC<CampaignPreviewParams> = ({ campaignId }) => {
  const [expanded, setExpanded] = useState(true)
  const { t } = useTranslation()

  const { data: campaignData, isPending } = useCampaign(campaignId)

  if (isPending || !campaignData) return null // Add a loading spinner here

  return (
    <LayoutAccordion
      title={
        campaignData?.assets?.length > 1
          ? t('campaignDashboard.campaignPreview.campaignSimulations')
          : t('campaignDashboard.campaignPreview.campaignSimulation')
      }
      expanded={expanded}
      onClick={() => setExpanded(!expanded)}>
      <StyledSliderWrpper>
        <SlickSlider
          centerMode={false}
          variableWidth={false}
          dots={true}
          arrows={false}
          slidesToScroll={1}
          slidesToShow={1}
          infinite={false}>
          {campaignData.assets?.map((simulationData: any, index: number) => (
            <Box key={index} height={campaignData.assets.length > 1 ? '360px' : 'none'}>
              <CampaignSimulationPreview simulationData={simulationData} />
            </Box>
          ))}
        </SlickSlider>
      </StyledSliderWrpper>
    </LayoutAccordion>
  )
}

const StyledSliderWrpper = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '& .slick-dots li': { width: '8px' },
  '& .slick-list': { paddingBottom: theme.spacing(2) },
  '& .slick-dots li button:before': { fontSize: '12px', marginBottom: '100px' },
  marginBottom: theme.spacing(3),
}))

export default CampaignPreview
